import { Injectable } from '@angular/core';
import { AuthService } from '@gelato-api-ui/core/auth/auth.service';
import {
  DesignEditorAllPlugins,
  DesignEditorPlugin,
} from '@gelato-api-ui/core/design-editor/types/design-editor-plugin.enum';
import { ResponsiveService } from '@gelato-api-ui/core/responsive/responsive.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { hiddenEmbroideryPlugins, notAvailablePluginsForGuest } from '../constants/action-availability.constants';

@Injectable({
  providedIn: 'root',
})
export class EditorUserActionAvailabilityService {
  private isGuest$ = this.auth.isGuest();
  isPrintFileBackToGelatoPage$ = this.isGuest$;

  constructor(private readonly auth: AuthService, private readonly responsive: ResponsiveService) {}

  getAvailablePlugins(hasEmbroidery = false): Observable<DesignEditorPlugin[]> {
    return this.isGuest$.pipe(
      map(isGuest =>
        DesignEditorAllPlugins.filter(plugin => {
          const isAvailable = isGuest ? !notAvailablePluginsForGuest.includes(plugin) : true;
          return isAvailable && (hasEmbroidery ? !hiddenEmbroideryPlugins.includes(plugin) : true);
        }),
      ),
    );
  }

  isSaveAsTemplateButtonAvailable$(
    fromTemplates: boolean,
    isActivationBranding: boolean,
    fromBranding: boolean,
  ): Observable<boolean> {
    return combineLatest([this.responsive.isMobile$, this.isGuest$]).pipe(
      map(([isMobile, isGuest]) => !isMobile && !isGuest && !fromTemplates && !isActivationBranding && !fromBranding),
    );
  }
}
